import { useState, useEffect, useRef } from 'react'
import { useLocation, useParams, Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import styles from './EventLoad.module.css'
import { AsyncPaginate } from 'react-select-async-paginate';
// ------ Services ------ //
import * as eventService from '../../../services/eventManagementService'
import * as clientEventService from '../../../services/clientEventService'
import * as kioskService from '../../../services/kioskService'
// ------ Components ------ //
import LoadingSpinner from "../../../components/Miscellaneous/LoadingSpinner"
import HoverButton from "../../../components/Miscellaneous/HoverButton"
const EventLoad = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const passedState = location.state
    const passedPath = location.pathname
    const [loaded, setLoaded] = useState(false)
    const [loadEventsObj, setLoadEventsObj] = useState({})
    const [selectedRegistrant, setSelectedRegistrant] = useState({})
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(15);
    const [reloadSelectionOptions, setReloadSelectionOptions] = useState([])
    const [reloadNameSelected, setReloadNameSelected] = useState("")
    const [reloadValueSelected, setReloadValueSelected] = useState(0)
    const [reloadLazyLoadSelected, setReloadLazyLoadSelected] = useState(true)
    const [reloadEventRequestBody, setReloadEventRequestBody] = useState({})
    const [reloadMode, setReloadMode] = useState('full') // 'full' | 'individual' (UI toggle only)
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current = passedData
        }

    }

    let reloadOptionSelectedIndex 
    const reloadAttendees = async e => {
        e.preventDefault()

        const appended = appendReloadOption()

        try {
            eventService.reloadEvent(appended)
        } catch (err) {
            console.log(err)
        }
        navigate(-1); // navigates back
    }
    const reloadAttendee = async e => {
        e.preventDefault()

        const appended = appendReloadOptionInd()

        try {
            eventService.reloadIndividual(appended)
        } catch (err) {
            console.log(err)
        }
        navigate(-1); // navigates back
    }

    const fetchRegistrantsReloadSelections = async () => {
        const registrantsReloadSelections = await eventService.getRegistrantReloadSelections()
        registrantsReloadSelections.map(choice => {
            // fix display for human eyes
            switch (choice.name) {
                case 'Everything':
                    choice.text = 'Everything'
                    choice.title = 'All registrants'
                    return choice
                case 'Last24hrs':
                    choice.text = 'Last 24 Hours'
                    choice.title = 'Registrants added within last day'
                    return choice
                case 'LastHr':
                    choice.text = 'Last Hour'
                    choice.title = 'Registrants added within last hour'
                    return choice
                case 'EverythingIncludeUnpaid':
                    choice.text = 'Everything(Include Unpaid)'
                    choice.title = 'All Registrants including unpaid'
                    return choice
                case 'Last24hrsIncludeUnpaid':
                    choice.text = 'Last 24 Hours(Include Unpaid)'
                    choice.title = 'Registrants added, including unpaid, within last day'
                    return choice
                case 'LastHrIncludeUnpaid':
                    choice.text = 'Last Hour(Include Unpaid)'
                    choice.title = 'Registrants added, including unpaid, within last hour'
                    return choice
                default:
                    return ''
            }
        });
        setReloadSelectionOptions(registrantsReloadSelections)

    }

    const fetchEventDetails = async () => {
        const eventDetail = await eventService.getEvent(appendEventRetrieval())
        setLoadEventsObj(eventDetail)
        // load event data reload status items
        fetchRegistrantsReloadSelections();
        setLoaded(true);
    }
    const appendEventRetrieval = () => {
        let result = {}
        // used passed data, if its there
        if (passedState && passedState.clientId && (passedState.clientId !== clientEventInfo.clientId
            || passedState.eventId || passedState.clientId !== clientEventInfo.eventId)) {
            result = {
                clientId: passedState.clientId,
                eventid: passedState.eventId,
            }
        }
        else {
            result = {
                clientId: clientEventInfo.clientId,
                eventid: clientEventInfo.eventId,
            }
        }
        return result
    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])
    useEffect(() => {
        if (clientEventInfo && clientEventInfo.clientId && clientEventInfo.clientId !== undefined) {
            fetchEventDetails();
        }
    }, [clientEventInfo])
    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }
        //document.getElementById('fullCheck').checked = true;
    }, [])

    const appendReloadOption = () => {
        let result = {}
        let clientidRef = loadEventsObj && loadEventsObj.clientId !== undefined && loadEventsObj.clientId !== '00000000-0000-0000-0000-000000000000' ? loadEventsObj.clientId : clientEventInfo.clientId;
        let eventidRef = loadEventsObj && loadEventsObj.eventId !== undefined && loadEventsObj.eventId !== '00000000-0000-0000-0000-000000000000' ? loadEventsObj.eventId : clientEventInfo.eventId;
        result = {
            clientId: clientidRef,
            eventid: eventidRef,
            RegistrantDataReloadSelections: reloadValueSelected,
            UseLazyLoad: reloadLazyLoadSelected,
        }
        return result
    }
    const appendReloadOptionInd = () => {
        let result = {}
        let clientidRef = loadEventsObj && loadEventsObj.clientId !== undefined && loadEventsObj.clientId !== '00000000-0000-0000-0000-000000000000' ? loadEventsObj.clientId : clientEventInfo.clientId;
        let eventidRef = loadEventsObj && loadEventsObj.eventId !== undefined && loadEventsObj.eventId !== '00000000-0000-0000-0000-000000000000' ? loadEventsObj.eventId : clientEventInfo.eventId;
        result = {
            clientId: clientidRef,
            eventid: eventidRef,
            RegistrantValue: selectedRegistrant.localRegistrationId,
        }
        return result
    }

    const createSearchBody = async (searchQuery) => {
        let requestBody = {}
        if (clientEventInfo && clientEventInfo.clientId) {
            if (passedState && passedState !== undefined && (passedState.clientId || passedState.clientId !== clientEventInfo.clientId
                || passedState.eventId || passedState.clientId !== clientEventInfo.eventId)) {
                requestBody =
                {
                    "clientId": `${passedState.clientId}`,
                    "eventId": `${passedState.eventId}`,
                    "searchValue": `${searchQuery}`,
                    "index": `${currentPage}`,
                    "pageSize": `${itemsPerPage}`,
                }
            }
            else {
                requestBody =
                {
                    "clientId": `${clientEventInfo.clientId}`,
                    "eventId": `${clientEventInfo.eventId}`,
                    "searchValue": `${searchQuery}`,
                    "index": `${currentPage}`,
                    "pageSize": `${itemsPerPage}`,
                }
            }
           
        }

        return await requestBody;
    }


    const loadOptions = async (searchQuery) => {
        const items = await kioskService.getSmallAttendeesSearchPaged(await createSearchBody(searchQuery));
        items.forEach((item) => {
            // has to have value and label defined
            item.value = item.localRegistrationId;
            item.label = item.firstName + ' ' + item.lastName + (item.organization ? ' (' + item.organization + ')' : '');
        })
        setSearchQuery(searchQuery)
        setCurrentPage(currentPage + 1)
        return {
            options: items,
            hasMore: items.length >= 1,
            //additional: {
            //    page: searchQuery ? 2 : page + 1,
            //},
        };

    };
    const onChange = option => {
        if (option) {
            option.clientId = clientEventInfo.clientId;
            option.eventId = clientEventInfo.eventId;
            option.clientName = clientEventInfo.clientName;
        }

        // triggered when option selected
        setSelectedRegistrant(option)
    };

    const onInputChange = entry => {
        // triggered when typing changes
        if (entry !== searchQuery) {
            // reset pages
            setCurrentPage(1)
            //setSelectedRegistrant({})
        }
    };
    const handleROChange = e => {
        // determine selected value's index to match numeric values on controller method for reload
        let selectedItem = reloadSelectionOptions.filter(pcl => pcl.name === e.target.value || pcl.text === e.target.value)[0]
        reloadOptionSelectedIndex = reloadSelectionOptions.indexOf(selectedItem)
        setReloadNameSelected(selectedItem.text)
        setReloadValueSelected(reloadOptionSelectedIndex)
    }
    const isFormInvalid = () => {
        return !(reloadNameSelected )
    }
    const isIndividualFormInvalid = () => {
        return !(selectedRegistrant && selectedRegistrant.firstName !== undefined)
    }
    const changeDateFormat = dateStr => {
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric' };
        const dateFormatted = date.toLocaleDateString('en-us', options);
        const returnDate = dateFormatted.split(' ').slice(1).join('/')
        return returnDate
    }
    return (
         <>{!loaded ? <LoadingSpinner /> :
         <>
            <div className="page-area">
                <div className={styles.eventCard}>
                    <h1>{loadEventsObj?.name || 'Client Events'}</h1>
                    {loadEventsObj?.startDate &&
                        <div className={styles.eventMeta}>
                            <span>{changeDateFormat(loadEventsObj.startDate)} – {changeDateFormat(loadEventsObj.endDate)}</span>
                            <span>Attendee Count: {loadEventsObj.count}</span>
                        </div>
                    }
                </div>

                <div id={styles.reloadSection}>
                    <fieldset className={styles.modeToggle}>
                        <legend>Select Full Event or Individual Registrant</legend>
                        <label className={reloadMode === 'full' ? styles.segActive : styles.seg}>
                            <input
                                type="radio"
                                name="reloadSelection"
                                checked={reloadMode === 'full'}
                                onChange={() => setReloadMode('full')}
                            />
                            Full Event
                        </label>
                        <label className={reloadMode === 'individual' ? styles.segActive : styles.seg}>
                            <input
                                type="radio"
                                name="reloadSelection"
                                checked={reloadMode === 'individual'}
                                onChange={() => setReloadMode('individual')}
                            />
                            Individual Registrant
                        </label>
                    </fieldset>

                    {reloadMode === 'full' ?
                        <div className={styles.panel}>
                            <h4>Full Event Reload Option</h4>
                            <label htmlFor={styles.ERSListDropdown}>Set Reload Option:</label>
                            <select
                                name="EventRegistrationSystem"
                                id={styles.ERSListDropdown}
                                value={reloadNameSelected}
                                onChange={handleROChange}
                            >
                                <option value="">
                                    -- Select an option --
                                </option>
                                {
                                    reloadSelectionOptions.map((reloadOption, idx) => (
                                        <option key={idx} value={reloadOption.value} title={reloadOption.title}>{reloadOption.text}
                                        </option>
                                    ))
                                }
                            </select>
                            <div className={styles.checkboxRow}>
                                <label title="When un-checked, immediate reload is used. When checked, lazy-loader is used.">
                                    <input
                                        name="Required"
                                        type="checkbox"
                                        onClick={() => setReloadLazyLoadSelected(!reloadLazyLoadSelected)}
                                        checked={reloadLazyLoadSelected}
                                    />
                                    Use lazy-loading
                                </label>
                                <HoverButton
                                    title={'Lazy-loading brings attendees in gradually in the background, so the reload finishes faster and stays responsive for large events. Turn it off to load every attendee all at once before the reload completes.'}
                                    messageWidth={320}
                                />
                            </div>
                            <button className={styles.primaryBtn} onClick={reloadAttendees} disabled={isFormInvalid()}>
                                Reload Attendees
                            </button>
                        </div>
                        :
                        <div className={styles.panel}>
                            <h4>Individual Registrant Reload</h4>
                            <label>Select Registrant:</label>
                            <div className={styles.searchField}>
                                <AsyncPaginate
                                    //value={searchTerm} // don't use with loadOptions, one or other
                                    loadOptions={loadOptions}//activates selections
                                    //getOptionValue={option => option.value}
                                    //getOptionLabel={option => option.label}
                                    onInputChange={onInputChange} // detects typing entry
                                    onChange={onChange} // option selected
                                    isClearable={true}
                                    isSearchable={true}
                                    placeholder={'Search for Registrant'}
                                    debounceTimeout={300}
                                />
                            </div>
                            <button className={styles.primaryBtn} onClick={reloadAttendee} disabled={isIndividualFormInvalid()}>
                                Reload Attendee
                            </button>
                        </div>
                    }
                </div>

                <button className={styles.secondaryBtn} onClick={() => navigate(-1)}>Back</button>
            </div>
         </>
        }
        </>

    );
}

export default EventLoad;